// Every page sets its own <title>, meta description and canonical, but only
// a few (home, spa, room/flavor/meeting-hall detail) also set og:title and
// og:description — the rest used to inherit the homepage's copies from
// app.vue, so link previews of /rooms, /about, /contact, ... all showed the
// homepage title and description, and no page had og:url at all.
//
// Fill og:title / og:description / og:url from the page's own resolved
// tags, only where the page hasn't set them explicitly. Runs per head
// instance, i.e. per SSR request.
export default defineNuxtPlugin(() => {
  const head = injectHead()

  head.hooks.hook('tags:afterResolve', ({ tags }) => {
    const findMeta = (attr: string, value: string) =>
      tags.find(t => t.tag === 'meta' && t.props[attr] === value)

    const addOg = (property: string, content?: string) => {
      if (!content || findMeta('property', property)) return
      tags.push({
        tag: 'meta',
        props: { property, content },
        _d: `meta:property:${property}`,
      } as (typeof tags)[number])
    }

    addOg('og:title', tags.find(t => t.tag === 'title')?.textContent)
    addOg('og:description', findMeta('name', 'description')?.props.content)
    addOg('og:url', tags.find(t => t.tag === 'link' && t.props.rel === 'canonical')?.props.href)
  })
})
